export const matrixLoader = {
  matrixListPeriode: 'matrixListPeriode',
  matrixStructureOrg: 'matrixStructureOrg',
  matrixValidation: 'matrixValidation',
  matrixViewProcess: 'matrixViewProcess',
  matrixViewStructure: 'matrixViewStructure',
  pivotTable: 'pivotTable',
};

export const initialStateMatrix = {
  matrixListPeriode: true,
  matrixStructureOrg: true,
  matrixValidation: true,
  matrixViewProcess: true,
  matrixViewStructure: true,
  pivotTable: true,
};
